import { CATALOGUE_MODE } from "@constants";
import { useSnapshot } from "valtio";

import React from "react";

import { getImageContentById } from "@helpers/general";

import { kioskStore } from "@pages/Kiosk/store";

type PrmBackgroundWrapperType = {
    isSummary?: boolean;
};
export function PrmBackgroundWrapper({
    isSummary,
}: PrmBackgroundWrapperType): JSX.Element {
    const {
        project: {
            files: images,
            template: { content, pages },
        },
        kioskWays,
        navigationIndex,
        isPrm,
    } = useSnapshot(kioskStore);

    const prmDesign = (content.generalDesign as GeneralDesignType)
        .prm as GeneralDesignPrmType;
    const prmBackgroundId = prmDesign.id;

    const prmContent = images[prmBackgroundId];

    let imageSrc = getImageContentById(prmBackgroundId as string);
    if (!imageSrc && prmDesign.defaultContent) {
        imageSrc = prmDesign.defaultContent;
    }

    const pageBackgroundActive =
        ((
            pages.ways[kioskWays[navigationIndex].name] as
                | PageType
                | PaymentPageType
                | OrderTakingPageType
                | PrinterOptionsPageType
                | ConsommationPageType
        )?.background?.active as boolean) ?? false;

    const isActiveBackground = isPrm && (pageBackgroundActive || !!imageSrc);

    const isVideo =
        (prmContent?.type?.includes("video") as boolean) ||
        /\.(webm|mp4|mov|ogg)$/i.test(imageSrc || "");

    return (
        <>
            {isActiveBackground && imageSrc ? (
                <div
                    style={{
                        minHeight:
                            kioskWays[navigationIndex].name === "orderTaking"
                                ? isSummary
                                    ? process.env.REACT_APP_MODE ===
                                      CATALOGUE_MODE
                                        ? "100vh"
                                        : "52vh"
                                    : "1145px"
                                : "unset",
                        maxHeight:
                            kioskWays[navigationIndex].name === "orderTaking"
                                ? "100%"
                                : "unset",
                        height:
                            kioskWays[navigationIndex].name === "salesMethods"
                                ? process.env.REACT_APP_MODE === CATALOGUE_MODE
                                    ? "100vh"
                                    : "52vh"
                                : isSummary
                                ? "unset"
                                : "100%",
                        width:
                            kioskWays[navigationIndex].name === "salesMethods"
                                ? "100%"
                                : isPrm
                                ? "100%"
                                : "",
                    }}
                >
                    {isVideo ? (
                        <video
                            autoPlay
                            loop
                            muted
                            className="w-100 h-100"
                            style={{
                                objectFit: "initial",
                            }}
                        >
                            <source src={imageSrc} />
                        </video>
                    ) : (
                        <img
                            className="w-100 h-100"
                            src={imageSrc}
                            alt="prm-background-image"
                        />
                    )}
                </div>
            ) : null}
        </>
    );
}
